import { connect } from 'react-redux';

import * as CliApp from 'app/entities/CliApp';
import * as DeveloperActions from 'app/developer-v3/Actions';
import * as EnvironmentVariable from 'app/entities/EnvironmentVariable';
import Redirects from 'app/developer-v3/pages/embed/settings/Redirects/Redirects';
import LoadingBlockOrComponent from 'app/common/components/LoadingBlockOrComponent';
import hocify from 'app/common/components/hocify';
import { createPartnerUserInteractionEventTracker } from 'app/developer-v3/teams/team-partner-sharing/createInteractionTracker';
import {
  currentAppEntity,
  lifecycleHasFailed,
  lifecycleHasFinished,
  lifecycleHasStarted,
  versionEnvironmentVariables,
} from 'app/developer-v3/selectors';

import type { State, StringMap } from 'app/common/types';

const mapStateToProps = (state: State) => {
  const isSaving =
    lifecycleHasStarted(state) &&
    !(lifecycleHasFinished(state) || lifecycleHasFailed(state));

  const appEntity = currentAppEntity(state);
  const trackInteraction = createPartnerUserInteractionEventTracker(state);
  const slug = CliApp.selectors.slug(appEntity);
  const appId = CliApp.selectors.id(appEntity);
  const envVars = versionEnvironmentVariables(state);
  const isLoadingApp = CliApp.selectors.isLoading(appEntity);
  const isLoadingEnvVars = EnvironmentVariable.selectors.all.isLoading(state);

  return {
    appId,
    isLoading: isLoadingApp || isLoadingEnvVars,
    isSaving,
    initialEnvVars: envVars,
    slug,
    trackInteraction,
  };
};

const mapDispatchToProps = (dispatch, props) => ({
  onLoad() {
    const { id, version } = props.params;
    dispatch([
      DeveloperActions.loadAppAndVersion(id, version),
      DeveloperActions.loadEnvironmentForVersion(),
    ]);
  },
  async saveEnv(env: StringMap) {
    await dispatch(DeveloperActions.batchUpdateEnvironmentVariables(env));
    dispatch(EnvironmentVariable.actions.resetAndLoadCollection());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(hocify(LoadingBlockOrComponent)(Redirects));
